import { apiFetch } from '@/lib/apiFetch';
import { handleUnauthorized } from './UserManagmentServices';

export interface DeletionInitiatedResponse {
  message: string;
  expiresAt: string;
}

export async function initiateStudentDeletion(
  accessToken: string
): Promise<DeletionInitiatedResponse> {
  const response = await apiFetch('/api/userManagement/v1/me/student-data', {
    method: 'DELETE',
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  if (response.status === 401) handleUnauthorized();
  if (!response.ok) throw new Error(`Failed to initiate student data deletion: ${response.status}`);
  return response.json();
}

export async function initiateTeacherDeletion(
  accessToken: string
): Promise<DeletionInitiatedResponse> {
  const response = await apiFetch('/api/userManagement/v1/me/teacher-data', {
    method: 'DELETE',
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  if (response.status === 401) handleUnauthorized();
  if (!response.ok) throw new Error(`Failed to initiate teacher data deletion: ${response.status}`);
  return response.json();
}

export async function initiateFullDeletion(
  accessToken: string
): Promise<DeletionInitiatedResponse> {
  const response = await apiFetch('/api/userManagement/v1/me', {
    method: 'DELETE',
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  if (response.status === 401) handleUnauthorized();
  if (!response.ok) throw new Error(`Failed to initiate full account deletion: ${response.status}`);
  return response.json();
}

/**
 * Confirms deletion using the one-time token from the email link.
 * No auth token required — the deletion token itself is the credential.
 */
export async function confirmDeletion(token: string): Promise<void> {
  const response = await apiFetch(
    `/api/userManagement/v1/me/confirm-deletion?token=${encodeURIComponent(token)}`,
    { method: 'POST' }
  );
  if (response.status === 204) return;
  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    throw new Error(body?.message ?? `Deletion confirmation failed: ${response.status}`);
  }
}
